export const logRequest = async (payload) => {
  try {
    // const response = await axios.post(`${baseUrl}/auth/log-request`, payload, {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // });
    // console.log("Log request response:", response.data);
  } catch (error) {
    console.error("Error logging request:", error);
  }
};

export const handleTokenExpiry = async (res, cb) => {
  if (res.message === "jwt expired") {
    localStorage.removeItem("token");
    cb();
  }
};
